import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { initAuthListener } from './stores/auth-store';
// Self-hosted: the fonts are bundled by Vite, so no CDN is contacted at runtime.
import '@fontsource-variable/space-grotesk';
import '@fontsource-variable/jetbrains-mono';
import './styles/global.css';
import './styles/app.css';
import './styles/auth.css';
import './styles/legal.css';

// Attach the Firebase listener before the first render. It resolves
// asynchronously, so the store starts in `loading` and ProtectedRoute holds the
// route decision until Firebase has replayed any persisted session.
initAuthListener();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
